(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els = document.querySelectorAll('[data-sw-reveal]:not(.is-in), .sw-cta:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
  }

  function hero(root){
    var track = root.querySelector('.sw-hero__track');
    var slides = root.querySelectorAll('.sw-hero__slide');
    var dots = root.querySelectorAll('.sw-hero__dot');
    if (!track || slides.length < 2) { slides[0] && slides[0].classList.add('is-active'); return; }
    var i = 0, timer = null, paused = false;
    function set(n, scroll){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); s.tabIndex = k === i ? 0 : -1; });
      dots.forEach(function(d, k){ d.classList.remove('is-active'); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
      if (scroll) track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function play(){ clearInterval(timer); if (!reduce) timer = setInterval(function(){ if (!paused) set(i + 1, true); }, 6000); }
    dots.forEach(function(d, k){ d.addEventListener('click', function(){ set(k, true); play(); }); });
    root.addEventListener('mouseenter', function(){ paused = true; });
    root.addEventListener('mouseleave', function(){ paused = false; });
    root.addEventListener('focusin', function(){ paused = true; });
    root.addEventListener('focusout', function(){ paused = false; });
    var t;
    track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(function(){ var n = Math.round(track.scrollLeft / track.clientWidth); if (n !== i) { set(n, false); play(); } }, 120); }, { passive: true });
    set(0, false); play();
  }

  function showcase(root){
    var names = root.querySelectorAll('.sw-show__name');
    var panels = root.querySelectorAll('.sw-show__panel');
    var disc = root.querySelector('.sw-show__disc');
    var mfacts = root.querySelectorAll('.sw-show__mfact');
    function pick(k){
      names.forEach(function(n, j){ n.setAttribute('aria-selected', j === k ? 'true' : 'false'); n.tabIndex = j === k ? 0 : -1; });
      panels.forEach(function(p, j){ p.classList.toggle('is-active', j === k); p.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
      mfacts.forEach(function(p, j){ p.hidden = j !== k; });
      if (disc && names[k]) disc.style.setProperty('--disc', names[k].dataset.disc);
    }
    names.forEach(function(n, k){
      n.addEventListener('click', function(){ pick(k); });
      n.addEventListener('mouseenter', function(){ if (window.matchMedia('(hover: hover)').matches) pick(k); });
      n.addEventListener('keydown', function(e){
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault(); var m = (k + d + names.length) % names.length; pick(m); names[m].focus();
      });
    });
    pick(0);
  }

  function dragRow(track){
    var down = false, moved = false, x0 = 0, s0 = 0;
    track.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft; });
    window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); } if (moved) track.scrollLeft = s0 - dx; });
    window.addEventListener('pointerup', function(){ if (!down) return; down = false; setTimeout(function(){ track.classList.remove('is-drag'); }, 30); });
  }

  function quickAdd(form){
    form.setAttribute('data-swk-skip', '');
    form.addEventListener('submit', function(e){
      if (!window.SwKorb) return;
      e.preventDefault();
      var btn = form.querySelector('button'); var label = btn.innerHTML;
      btn.disabled = true;
      window.SwKorb.add([{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }]).then(function(){
        btn.classList.add('is-added'); btn.textContent = btn.dataset.added || 'OK';
      }).catch(function(){}).then(function(){
        setTimeout(function(){ btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 1800);
      });
    });
  }

  function sticky(bar){
    var target = document.querySelector('[data-sw-buy]') || document.querySelector('.product-form__submit');
    if (!target || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.sw-foot');
    var past = false, nearFoot = false;
    function upd(){ bar.classList.toggle('is-on', past && !nearFoot); }
    new IntersectionObserver(function(en){ past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; upd(); }).observe(target);
    if (footer) new IntersectionObserver(function(en){ nearFoot = en[0].isIntersecting; upd(); }).observe(footer);
    var btn = bar.querySelector('button');
    btn && btn.addEventListener('click', function(){ var t = document.querySelector('[data-sw-buy]') || document.querySelector('.product-form__submit'); if (t && t.hasAttribute('data-sw-buy')) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); else if (t && !t.disabled) t.click(); else window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function init(){
    document.querySelectorAll('.sw-hero').forEach(hero);
    document.querySelectorAll('.sw-show').forEach(showcase);
    document.querySelectorAll('.sw-row__track').forEach(dragRow);
    document.querySelectorAll('form.sw-quick').forEach(quickAdd);
    document.querySelectorAll('.sw-sticky').forEach(sticky);
    reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
